'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CollectedAwardsReportController = function () {
  function CollectedAwardsReportController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService, fRegistrationService) {
    var _this = this;

    _classCallCheck(this, CollectedAwardsReportController);

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this._reg = fRegistrationService.for(feis.id);

    // Required fields:
    // Level	Comp	Age	Type	Event	Placed	Placement	First	Last	Number	Score	Collected
    // comp == e.name
    // event == e.event
    this.headers = ['Level', 'Comp', 'Age', 'Type', 'Event', 'Placed', 'Placement', 'First', 'Last', 'Number', 'Score', 'Collected?'];
    this._reg.all().then(function (participants) {
      _this.events = {};
      participants.forEach(function (p) {
        p.registrations.forEach(function (r) {
          var eventName = r.event.name;
          var event = r.event;

          if (!event.is_in_results) return;

          if (!_this.events[eventName]) {
            delete event.participants;
            event.level = event.level ? event.level : '';
            event.participants = [];
            _this.events[eventName] = event;
          }

          // next push placed participant data...
          if (r.placed) {
            var participant = {};
            participant.placed = r.placed ? "yes" : "no";
            participant.placement = r.placement;
            participant.fname = p.fname;
            participant.lname = p.lname;
            participant.competitor = p.competitor;
            participant.total = r.total;
            participant.computedTotal = r.computedTotal;
            participant.collected = r.collected ? "yes" : "no";
            _this.events[eventName].participants.push(participant);
          }
        });
      });

      // sort by event number
      _this.events = Object.entries(_this.events).sort(function (_ref, _ref2) {
        var _ref4 = _slicedToArray(_ref, 1),
            keyA = _ref4[0];

        var _ref3 = _slicedToArray(_ref2, 1),
            keyB = _ref3[0];

        return parseInt(keyA.match(/^\d+/)[0], 10) - parseInt(keyB.match(/^\d+/)[0], 10);
      }).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            eventData = _ref6[1];

        return eventData;
      });
    });
  }

  _createClass(CollectedAwardsReportController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var csv = [];
      csv.push(this.headers);

      // Level	Comp	Age	Type	Event	Placed	Placement	First	Last	Number	Score	Collected
      this.events.forEach(function (e) {
        e.participants.forEach(function (p) {
          csv.push([e.level || 'n/a', String(e.name), e.age, e.type, e.event, p.placed, p.placement ? String(p.placement) : 'n/a', p.fname, p.lname, p.competitor ? String(p.competitor) : 'n/a', p.total || 'n/a', p.collected]); // change collected value to true or false
        });
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Collected_Awards.csv');
    }
  }]);

  return CollectedAwardsReportController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.collected-awards-report', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.collected-awards-report', {
    url: '/collected-awards-report',
    template: require('./tpl.html'),
    controller: CollectedAwardsReportController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/collected-awards/index.js
// module id = 559
// module chunks = 0